module.exports = __webpack_public_path__ + "img/bg-forgot.36bbeeab.jpg";